import IconButton from '@components/v2/ui/IconButton/IconButton';
import { X } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface ProductDetailsCloseButtonProps {
  className?: string;
  onClick: () => void;
}

const ProductDetailsCloseButton = ({ className, onClick }: ProductDetailsCloseButtonProps) => {
  const { translate } = useTranslation();

  return (
    <IconButton
      icon={X}
      size="medium"
      shape="round"
      tabIndex={-1}
      testId="product-details-close"
      className={className}
      ariaLabel={translate(LangEnum.GLOBAL_CLOSE)}
      onClick={onClick}
    />
  );
};

export default ProductDetailsCloseButton;
